interface Properties {
  onDelete?: () => void;
}

const DeleteButton: React.FC<Properties> = ({ onDelete, ...props }) => {
  return (
    <button
      className="border-none bg-white rounded-full absolute -right-2 -top-2 shadow-xl p-1"
      onClick={onDelete}
      {...props}
    >
      <svg
        width="28"
        height="28"
        viewBox="0 0 28 28"
        fill="none"
        xmlns="http://www.w3.org/2000/svg"
      >
        <path
          d="M8.13051 8.13051C8.21179 8.04902 8.30834 7.98437 8.41465 7.94026C8.52095 7.89615 8.63491 7.87344 8.75001 7.87344C8.8651 7.87344 8.97906 7.89615 9.08537 7.94026C9.19167 7.98437 9.28823 8.04902 9.36951 8.13051L14 12.7628L18.6305 8.13051C18.7119 8.04915 18.8084 7.98462 18.9147 7.94059C19.021 7.89656 19.135 7.8739 19.25 7.8739C19.3651 7.8739 19.479 7.89656 19.5853 7.94059C19.6916 7.98462 19.7882 8.04915 19.8695 8.13051C19.9509 8.21186 20.0154 8.30844 20.0594 8.41474C20.1035 8.52103 20.1261 8.63496 20.1261 8.75001C20.1261 8.86506 20.1035 8.97898 20.0594 9.08528C20.0154 9.19157 19.9509 9.28815 19.8695 9.36951L15.2373 14L19.8695 18.6305C19.9509 18.7119 20.0154 18.8084 20.0594 18.9147C20.1035 19.021 20.1261 19.135 20.1261 19.25C20.1261 19.3651 20.1035 19.479 20.0594 19.5853C20.0154 19.6916 19.9509 19.7882 19.8695 19.8695C19.7882 19.9509 19.6916 20.0154 19.5853 20.0594C19.479 20.1035 19.3651 20.1261 19.25 20.1261C19.135 20.1261 19.021 20.1035 18.9147 20.0594C18.8084 20.0154 18.7119 19.9509 18.6305 19.8695L14 15.2373L9.36951 19.8695C9.28815 19.9509 9.19157 20.0154 9.08528 20.0594C8.97898 20.1035 8.86506 20.1261 8.75001 20.1261C8.63496 20.1261 8.52103 20.1035 8.41474 20.0594C8.30844 20.0154 8.21186 19.9509 8.13051 19.8695C8.04915 19.7882 7.98462 19.6916 7.94059 19.5853C7.89656 19.479 7.8739 19.3651 7.8739 19.25C7.8739 19.135 7.89656 19.021 7.94059 18.9147C7.98462 18.8084 8.04915 18.7119 8.13051 18.6305L12.7628 14L8.13051 9.36951C8.04902 9.28823 7.98437 9.19167 7.94026 9.08537C7.89615 8.97906 7.87344 8.8651 7.87344 8.75001C7.87344 8.63491 7.89615 8.52095 7.94026 8.41465C7.98437 8.30834 8.04902 8.21179 8.13051 8.13051Z"
          fill="#ED5050"
        />
      </svg>
    </button>
  );
};

export default DeleteButton;
